<form [formGroup]="form" (ngSubmit)="submit()">
  <div mat-dialog-content class="px-4 pb-0">
    <p i18n>Enter your email address to recieve reset instructions. You may need to
      check your spam folder.</p>
    <div>
      <small class="text-muted" i18n>Email address</small>
      <mat-form-field appearance="fill" class="ft-form-field--nolabel w-100">
        <input type="email" matInput formControlName="email" maxlength="60" />
        @if (form.get('email')?.invalid) {
        <mat-error>{{
          appService.getErrorMessage(form.get('email'))
          }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <button type="button" mat-button [disabled]="submitting()" mat-dialog-close i18n>Cancel</button>
    <button type="submit" mat-flat-button color="primary" [disabled]="submitting()">
      @if (!submitting()) {
      <span i18n>Submit</span>
      } @else {
      <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
      }
    </button>
  </div>
</form>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>